package com.esoris.kmpmoout.domaindata.product

import kotlinx.browser.window
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class LocalStorageProductRepositoryImpl :
    ProductRepository {

    companion object {
        private const val PRODUCTS_KEY =
            "products"
    }

    private val json = Json {

        ignoreUnknownKeys = true
    }

    private val _products =
        MutableStateFlow(
            loadProducts()
        )

    override fun getProducts():
            Flow<List<Product>> {

        return _products.asStateFlow()
    }

    override suspend fun insertProduct(
        product: Product
    ) {

        val updated =
            _products.value + product

        saveProducts(updated)

        _products.value = updated
    }

    override suspend fun deleteProduct(
        id: String
    ) {

        val updated =

            _products.value.filterNot {
                it.id == id
            }

        saveProducts(updated)

        _products.value = updated
    }

    private fun saveProducts(
        products: List<Product>
    ) {

        val jsonString =

            json.encodeToString(products)

        window.localStorage.setItem(
            PRODUCTS_KEY,
            jsonString
        )
    }

    private fun loadProducts():
            List<Product> {

        val raw =

            window.localStorage.getItem(
                PRODUCTS_KEY
            ) ?: return emptyList()

        return try {

            json.decodeFromString(raw)

        } catch (_: Exception) {

            emptyList()
        }
    }
}